import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import axios from '../../helpers/axios';
import { Grid, Card, CardContent, CardActions, CardHeader, IconButton, Button, Menu, MenuItem, Modal, Box, Divider, FormControl, Select, InputLabel, TextField, Typography, Backdrop, CircularProgress, Dialog, DialogTitle, DialogActions } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';
import AlertsHeader from './AlertsHeader';
import { DataGrid, GridRowParams, GridActionsCellItem, GridCellParams, GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid';
import { EditOutlined, Add, Security as SecurityIcon, FileCopy as FileCopyIcon, MoreHorizOutlined, CloseOutlined } from '@mui/icons-material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';


const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '65%',
    p: 4,
    height: '90%',
    overflowX: 'scroll'
};

function CustomToolbar() {
    return (
        <GridToolbarContainer className='exportButton'>
            <GridToolbarExport variant='contained' csvOptions={{ fileName: 'Outgoing-waste' }} />
        </GridToolbarContainer>
    );
}

export interface IProps {
    user: {
        id: number;
        name: string;
        email: string;
        role: string;
        is_active: boolean;
        selectedHierarchies: any[];
        selectedHierarchyIds: any[];
    };
}

export interface IState {
    notifications: any[];
    pageSize: number;
    anchorEl: any;
    showAddWaste: boolean;
    rowCount: any;
    /**Add waste by Vehicle Form Data */
    date?: string | null;
    /**Add waste by Vehicle Form Data */
    showDetails: boolean;
    showLoader: boolean;
    rowInfo: any;
    routes: any;
    communityNames: any;
    showDeleteModal: boolean;
    deleteNotificationId: any;
}

class Notifications extends React.Component<RouteComponentProps & IProps & WithTranslation, IState> {
    constructor(props: RouteComponentProps & IProps & WithTranslation) {
        super(props);
        this.state = {
            notifications: [],
            pageSize: 10,
            anchorEl: null,
            rowCount: 0,
            showAddWaste: false,
            date: null,
            showDetails: false,
            showLoader: false,
            rowInfo: {},
            routes: [],
            communityNames: '',
            showDeleteModal: false,
            deleteNotificationId: '',
        }
    }
    public componentDidMount(): void {
        // axios.get(`notifications`).then(response => {
        //     this.setState({ notifications: response.data.data })
        // });
        // this.setState({
        //     notifications: [
        //         {
        //             "id": 234,
        //             "title": "Win Rs.1000 Amazon gift card by participating in a 30-minute survey!",
        //             "description": "Get a chance to win a Rs.1000 Amazon gift card by taking part in a quick 30-minute consumer research session from the comfort of your home on April 6, 2023. Limited slots available.",
        //             "start_date": "2023-08-29 00:00:00",
        //             "expiry_date": "2023-09-15 00:00:00",
        //             "community": 12
        //         },
        //         {
        //             "id": 235,
        //             "title": "Exciting Prize Giveaway! Win Big!",
        //             "description": "Participate in our exciting prize giveaway and stand a chance to win amazing prizes. Don't miss out on this opportunity!",
        //             "start_date": "2023-09-01 00:00:00",
        //             "expiry_date": "2023-09-10 00:00:00",
        //             "community": 15
        //         },
        //         {
        //             "id": 236,
        //             "title": "Join our Health and Fitness Challenge!",
        //             "description": "Kickstart your fitness journey by joining our community's Health and Fitness Challenge. Get fit and win prizes!",
        //             "start_date": "2023-08-25 00:00:00",
        //             "expiry_date": "2023-09-30 00:00:00",
        //             "community": 7
        //         },
        //         {
        //             "id": 237,
        //             "title": "Food Festival - Taste the World!",
        //             "description": "Experience a world of flavors at our community's Food Festival. Sample dishes from different cuisines and enjoy the festivities.",
        //             "start_date": "2023-09-10 00:00:00",
        //             "expiry_date": "2023-09-18 00:00:00",
        //             "community": 9
        //         },
        //         {
        //             "id": 238,
        //             "title": "Community Cleanup Day - Be the Change!",
        //             "description": "Join us for a day of community service as we clean up our neighborhood. Make a difference and win prizes!",
        //             "start_date": "2023-09-05 00:00:00",
        //             "expiry_date": "2023-09-06 00:00:00",
        //             "community": 14
        //         },
        //         {
        //             "id": 239,
        //             "title": "Gardening Workshop - Green Thumb",
        //             "description": "Learn the art of gardening in our workshop and cultivate your own green paradise. Register now!",
        //             "start_date": "2023-09-12 00:00:00",
        //             "expiry_date": "2023-09-25 00:00:00",
        //             "community": 8
        //         },
        //         {
        //             "id": 240,
        //             "title": "Kids' Talent Show - Showcase Your Skills!",
        //             "description": "Let your child's talents shine at our Kids' Talent Show. Prizes for the most amazing performances!",
        //             "start_date": "2023-09-08 00:00:00",
        //             "expiry_date": "2023-09-12 00:00:00",
        //             "community": 10
        //         }
        //     ]
        // })
        this.fetchNotifications();
        this.fetchRoutes();
    }

    public fetchNotifications = (page: any = 0, limit: any = this.state.pageSize) => {
        this.setState({ showLoader: true });
        let option = {
            'page': page+1,
            'limit': limit,
            'type': 'promo'
        }
        axios.get('getAllNotifications', { params: option }).then((response) => {
            if (response.data.success) {
                // console.log(response.data.data.data);
                this.setState({ rowCount: response.data.data.total, showLoader: false });
                let data = response.data.data.data;
                this.setState({ notifications: data.filter((el: any) => el.type == 'promo') })
                console.log("notifications", this.state.notifications);
            } else {
                this.setState({ showLoader: false });
                toast.error(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                let errors = response.data.errors;
                for (var error in errors) {
                    toast.error(errors[error][0], {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                }
            }
        })
    }

    public fetchRoutes() {
        axios.get(`allCommunitiesLite`, {
            params: { hierarchies: this.props.user.selectedHierarchyIds },
        }).then((response) => {
            let data: any = response.data.data;
            let routes: any = [];
            data.map((route: any) => {
                routes[route.id] = {
                    id: route.id,
                    route: route.name,
                    hierarchy_id: route.hierarchy_id,
                    hierarchy_name: route.hierarchy_name,
                };
            });
            this.setState({ routes: routes });
        });
    }

    public deleteNotifications = (id: any) => {
        let data = {
            "notification_id": id
        }
        axios.post('deleteNotification', data, { headers: { "Content-Type": "application/json" } }).then((response: any) => {
            if (response.data.success) {
                toast.success(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                this.fetchNotifications();
            } else {
                toast.error(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                let errors = response.data.errors;
                for (var error in errors) {
                    toast.error(errors[error][0], {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                }
            }
        })
        this.fetchNotifications();
        this.setState({ showDeleteModal: false });
    }

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;
        const open = Boolean(this.state.anchorEl);

        const simpleTextFn = (des: any) => {
            let html = des;
            let div = document.createElement('div');
            div.innerHTML = html;
            var text = div.innerText || div.textContent || "";
            return text;
        }

        const findCommunitiesNames = (commIds: any) => {
            // console.log("abcd", commIds);
            if (commIds != null) {
                let arr = commIds.split(",")
                console.log("arr", arr);
                let commNames: any = [];
                if (arr[0] == 'all') {
                    commNames.push("All");
                    this.setState({ communityNames: [...commNames].join(", ") });
                } else {
                    let temp = this.state.routes.filter((el: any) => arr.includes(String(el.id)))
                    for (let i = 0; i < temp.length; i++) {
                        commNames.push(temp[i].route);
                    }
                    this.setState({ communityNames: [...commNames].join(", ") });
                    // console.log(commNames.join());
                }
            } else {
                this.setState({ communityNames: [] });
            }
        }


        const columns: any = [
            {
                headerName: "Id",
                field: "id",
                width: 100,
                renderCell: (params: GridCellParams) => (
                    <span style={{ cursor: 'pointer' }}>
                      {params.value}
                    </span>
                  )
                // renderCell: (params: GridCellParams) => (
                //     <Link to={`/notifications/${params.id}`} style={{ textDecoration: 'none' }}>{params.row.route}</Link>
                // )
            },
            {
                headerName: "Created By",
                field: "created_by_user_name",
                width: 180,
                renderCell: (params: GridCellParams) => (
                    <span style={{ cursor: 'pointer' }}>
                      {params.value || '-'}
                    </span>
                  )
            },
            {
                headerName: "Title",
                field: "title",
                width: 350,
                renderCell: (params: GridCellParams) => (
                    <span style={{ cursor: 'pointer' }}>
                      {params.value}
                    </span>
                  )
            },
            {
                headerName: "Description",
                field: "description",
                width: 350,
                renderCell: (params: GridCellParams) => (
                    <Typography style={{cursor:'pointer'}}>{simpleTextFn(params.row.description)}</Typography>
                )
            },
            {
                headerName: "Start Date",
                field: "visible_from",
                width: 150,
                renderCell: (params: GridCellParams) => (
                    <span style={{ cursor: 'pointer' }}>
                      {params.value}
                    </span>
                  )
            },
            {
                headerName: "Expiry Date",
                field: "visible_till",
                width: 150,
                renderCell: (params: GridCellParams) => (
                    <span style={{ cursor: 'pointer' }}>
                      {params.value}
                    </span>
                  )
            },
            {
                headerName: "User",
                field: 'individual_users',
                width: 150,
                renderCell: (params: GridCellParams) => (
                    <span style={{ cursor: 'pointer' }}>
                      {params.value}
                    </span>
                  )
            },
            {
                headerName: "Community",
                field: "communities",
                width: 150,
                renderCell: (params: GridCellParams) => (
                    <span style={{ cursor: 'pointer' }}>
                      {params.value}
                    </span>
                  )
            },
            {
                headerName: "Actions",
                field: 'actions',
                type: 'actions',
                getActions: (params: GridRowParams) => [

                    <GridActionsCellItem
                        label="Delete"
                        onClick={() => this.setState({ showDeleteModal: true, deleteNotificationId: params.row.id })}
                        showInMenu
                    />
                ]
            }
        ];

        return (
            <div>
                <Backdrop
                    sx={{ zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                    open={this.state.showLoader}
                    // onClick={() => this.setState({ showLoader: false })}
                >
                    <CircularProgress className='customLoader' />
                </Backdrop>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <AlertsHeader fetchNotifications={this.fetchNotifications} />
                <Grid container spacing={2}>
                    <Grid item md={12} xs={12} className="mt-3">
                        <Card>
                            {/* <CardHeader
                                title="Notifications"
                                className="text-left"
                                
                            />
                            <CardActions>
                                <Button variant='contained' sx={{ outline: 'none !important' }} onClick={() => this.setState({ showAddWaste: true })}><Add /> Add Outgoing Waste</Button>
                            </CardActions> */}
                            <CardContent>
                                <DataGrid
                                    aria-label="Outgoing Waste List"
                                    columns={columns}
                                    rows={this.state.notifications}
                                    rowCount={this.state.rowCount}
                                    pageSize={this.state.pageSize}
                                    onPageChange={(page) => this.fetchNotifications(page)}
                                    onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize }, () => this.fetchNotifications(0, newPageSize))}
                                    rowsPerPageOptions={[10, 20, 50, 100]}
                                    // autoHeight={true}
                                    style={{height: 500}}
                                    components={{
                                        MoreActionsIcon: EditOutlined,
                                        Toolbar: CustomToolbar
                                    }}
                                    onRowClick={(params: GridRowParams) => this.setState({ showDetails: true, rowInfo: params.row }, () => findCommunitiesNames(params.row.communities))}
                                    componentsProps={{ toolbar: { csvOptions: { fileName: 'Tickets-list' } } }}
                                    paginationMode="server"
                                // checkboxSelection
                                />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <Modal
                    open={this.state.showDetails}
                    onClose={() => this.setState({ showDetails: false })}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Card>
                            <CardHeader
                                title="Details"
                                className="text-left"
                                action={
                                    <IconButton color="primary" className='customIconButton' aria-label="upload picture" component="span" onClick={() => this.setState({ showDetails: false })}>
                                        <CloseOutlined />
                                    </IconButton>
                                }
                            />
                            <CardContent>
                                <Divider className="mb-3" />
                                <Grid container spacing={2}>
                                    <Grid item md={2} xs={12}>
                                        <Typography>Id : </Typography>
                                    </Grid>
                                    <Grid item md={10} xs={12}>
                                        <Typography>{this.state.rowInfo.id}</Typography>
                                    </Grid>
                                    <Grid item md={2} xs={12}>
                                        <Typography>Title :</Typography>
                                    </Grid>
                                    <Grid item md={10} xs={12}>
                                        <Typography>{this.state.rowInfo.title}</Typography>
                                    </Grid>
                                    <Grid item md={2} xs={12}>
                                        <Typography>Description : </Typography>
                                    </Grid>
                                    <Grid item md={10} xs={12}>
                                        <Typography dangerouslySetInnerHTML={{ __html: this.state.rowInfo.description }} />
                                    </Grid>
                                    {
                                        this.state.rowInfo.image && this.state.rowInfo.image.map((el: any, index: any) => (
                                            <Grid item md={12} xs={12}>
                                                <img src={axios.defaults.baseURL?.replace('/api/v1/admin/', '').replace('master','api')+el} alt={"Image"+index} style={{width: '100%'}}/>
                                            </Grid>
                                        ))
                                    }
                                    <Grid item md={2} xs={12}>
                                        <Typography>Communities : </Typography>
                                    </Grid>
                                    <Grid item md={10} xs={12}>
                                        <Typography>{this.state.communityNames}</Typography>
                                    </Grid>
                                    <Grid item md={2} xs={12}>
                                        <Typography>Start Date : </Typography>
                                    </Grid>
                                    <Grid item md={10} xs={12}>
                                        <Typography>{this.state.rowInfo.visible_from}</Typography>
                                    </Grid>
                                    <Grid item md={2} xs={12}>
                                        <Typography>Expiry Date : </Typography>
                                    </Grid>
                                    <Grid item md={10} xs={12}>
                                        <Typography>{this.state.rowInfo.visible_till}</Typography>
                                    </Grid>
                                </Grid>

                                <Divider className='mt-3' />
                            </CardContent>
                            <CardActions className='float-right'>
                                <Button size='small' className='customCloseButton' onClick={() => this.setState({ showDetails: false })}>Close</Button>
                            </CardActions>
                        </Card>
                    </Box>
                </Modal>
                <Dialog
                    open={this.state.showDeleteModal}
                    onClose={() => this.setState({ showDeleteModal: false })}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {t("Are you sure ? You want to delete this offer ?")}
                    </DialogTitle>
                    <DialogActions>
                        <Button onClick={() => this.setState({ showDeleteModal: false })}>{t("Cancel")}</Button>
                        <Button onClick={() => this.deleteNotifications(this.state.deleteNotificationId)} autoFocus>{t("Ok")}</Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

export default withRouter(withTranslation()(Notifications))
